import { Segment, Header, Container } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import loadable from '@loadable/component';
import { useInView } from 'react-intersection-observer';
const YouTubeLatestVideos = loadable(() => import('./YouTubeLatestVideos'), {ssr: false});


const View = (props) => { 
  const { data, mode, content } = props;
  const { ref, inView } = useInView({ triggerOnce: true });

  return (
    <section className="youtubeChannel__wrapper  styled py-5 px-0 liveSection d-print-none full-width bg-gray-bg has--background" ref={ref}>
      <Container className="  position-relative">
        {data?.title ? (
          <Header className='mb-4 headline text-center' as="h2">{data.title}</Header>
          ) : (
          <Header className='visually-hidden' as="h2"><FormattedMessage id="Canal Youtube" defaultMessage="Canal Youtube" /></Header>
        )}

        {inView && <YouTubeLatestVideos />}
        
      </Container>
    </section>
  );
};

export default injectIntl(View);